"use strict";
exports.__esModule = true;
var SlotType;
(function (SlotType) {
    SlotType["LOGICAL"] = "LOGICAL";
    SlotType["WIDGET"] = "WIDGET";
    SlotType["TABS"] = "TABS";
    SlotType["TAB_WIDGET"] = "TAB_WIDGET";
})(SlotType = exports.SlotType || (exports.SlotType = {}));
